export const iconFontAwesomeWritingBoxArchive = (
	<i className="fa-solid fa-box-archive"></i>
);
